"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeasonInput = SeasonInput;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
var _AutoCompleteInput = require("./AutoCompleteInput");
var _reactHookForm = require("react-hook-form");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Q_SEASONS = (0, _client.gql)`
  query seasons {
    games(distinct_on: season, order_by: {season: desc_nulls_last}) {
      season
    }
  }
`;
function SeasonInput(props) {
  const date = (0, _reactHookForm.useWatch)({
    control: props.control,
    name: 'date'
  });
  _react.default.useEffect(() => {
    if (date) {
      // January is a bowl game and is in the previous season
      if (date.$M === 0) {
        props.setValue('season', date.$y - 1);
      } else {
        props.setValue('season', date.$y);
      }
    }
  }, [date, props]);
  return /*#__PURE__*/_react.default.createElement(_AutoCompleteInput.AutoCompleteInput, _extends({
    query: Q_SEASONS,
    field: "season"
  }, props, {
    sx: {
      width: 100
    }
  }));
}